import { Controller } from '@hotwired/stimulus'

// Caps a numeric input to a fixed number of digits (default 4).
export default class extends Controller {
  static values = { length: { type: Number, default: 4 } }

  connect() {
    this.element.addEventListener('input', this.#cap)
  }

  disconnect() {
    this.element.removeEventListener('input', this.#cap)
  }

  #cap = () => {
    const value = String(this.element.value || '')
    if (value.length > this.lengthValue) {
      this.element.value = value.slice(0, this.lengthValue)
    }
  }
}
